// Set to true to bring the rental (location) section back on the public site.
export const LOCATION_ENABLED = false;
